import { render, staticRenderFns } from "./RedteaReady.vue?vue&type=template&id=62e0bade"
import script from "./RedteaReady.vue?vue&type=script&lang=js"
export * from "./RedteaReady.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports